// Apolo IDE — ConfirmDialog (ui, sprint composer-anchor E3).
//
// Confirmação cirúrgica pro irreversível (NN/g — usar com parcimônia). <dialog>
// nativo: Tab-trap + Esc + foco gerenciados pelo browser. O Cancelar recebe o
// autofocus (quem dá Enter por reflexo CANCELA, não confirma). Botões nomeados
// pelo chamador — nunca "OK/Cancelar" genérico.

import { useEffect, useRef } from 'react';

/**
 * @param {{ open: boolean, title: string, description?: string, confirmLabel: string,
 *   cancelLabel?: string, tone?: 'warning'|'danger'|'default', onConfirm: () => void, onCancel: () => void }} props
 */
export default function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel,
  cancelLabel = 'Cancelar',
  tone = 'warning',
  onConfirm,
  onCancel,
}) {
  const ref = useRef(null);
  const cancelRef = useRef(null);

  useEffect(() => {
    const dlg = ref.current;
    if (!dlg) return;
    if (open && !dlg.open) {
      dlg.showModal();
      // Cancelar pega o foco: Enter reflexo = cancelar.
      requestAnimationFrame(() => cancelRef.current?.focus());
    }
    if (!open && dlg.open) dlg.close();
  }, [open]);

  if (!open) return null;

  const confirmTone =
    tone === 'danger'
      ? 'border-apolo-error text-apolo-error hover:bg-apolo-errorBg'
      : tone === 'warning'
        ? 'border-apolo-warning text-apolo-warning hover:bg-apolo-warningBg'
        : 'border-apolo-borderStrong text-apolo-textPrimary hover:bg-apolo-surface2';

  return (
    <dialog
      ref={ref}
      aria-labelledby="confirm-dialog-title"
      onClose={onCancel}
      onCancel={onCancel}
      className="m-auto max-w-[min(26rem,92vw)] rounded-xl border border-apolo-borderSubtle bg-apolo-surface1 p-0 text-apolo-textPrimary backdrop:bg-apolo-overlay"
    >
      <div className="flex flex-col gap-3 p-5">
        <h2 id="confirm-dialog-title" className="text-base font-medium">
          {title}
        </h2>
        {description && (
          <p className="text-[13px] leading-relaxed text-apolo-textSecondary">{description}</p>
        )}
        <div className="mt-1 flex items-center justify-end gap-2">
          <button
            ref={cancelRef}
            type="button"
            onClick={onCancel}
            className="h-9 rounded-md border border-apolo-borderSubtle px-3 text-sm text-apolo-textSecondary transition hover:bg-apolo-surface2 hover:text-apolo-textPrimary focus:outline-none focus-visible:ring-2 focus-visible:ring-apolo-accentRing"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={`h-9 rounded-md border bg-apolo-surface1 px-3 text-sm font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-apolo-accentRing ${confirmTone}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </dialog>
  );
}
